import {
  Box,
  CloseButton,
  Icon,
  Link,
  ListItem,
  OrderedList,
  Text
} from '@chakra-ui/react'
import WarningIcon from '@material-ui/icons/Warning'
import WarningSharp from '@material-ui/icons/WarningSharp'
import React from 'react'
import ReactMarkdown from 'react-markdown'

interface TooltipContentProps {
  message: string
}

/**
 * This is a tooltip for the telehealth toggle on the app.
 */
export const TelehealthToggleTooltipContent: React.FC<TooltipContentProps> = ({
  message
}) => {
  return (
    <Box>
      <ReactMarkdown
        components={{
          a: ({ node, ...props }) => (
            <Link
              color="blue.500"
              textDecoration="underline"
              isExternal
              {...props}
            />
          ),
          p: ({ node, ...props }) => <Text as="span" {...props} />,
          strong: ({ node, ...props }) => (
            <Text as="span" fontWeight="bold" {...props} />
          ),
          ol: ({ node, ...props }) => (
            <OrderedList ml="2em" styleType="inside" spacing={2} {...props} />
          ),
          li: ({ node, ...props }) => <ListItem {...props} />
        }}
      >
        {message}
      </ReactMarkdown>
    </Box>
  )
}

export const WarningTooltip = ({
  message,
  onClose
}: {
  message: React.ReactNode
  onClose: () => void
}) => {
  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClose()
  }

  return (
    <Box py={2} pl={2} pr={1} display="flex" width="100%">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flex="1"
      >
        <Icon as={WarningIcon} color="red.500" mr="16px" boxSize={6} />
        {message}
      </Box>
      <CloseButton
        onClick={handleClose}
        size="sm"
        ml={1}
        color="#757575"
        position="relative"
      />
    </Box>
  )
}

/**
 * This is a tooltip for the chrome extension UX.
 */
export const WarningTooltipExtension = ({
  message,
  onClose
}: {
  message: React.ReactNode
  onClose: () => void
}) => {
  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClose()
  }

  return (
    <Box display="flex" alignItems="flex-start">
      <Box mr={2} flex="0">
        <WarningSharp />
      </Box>
      {message}
      <CloseButton
        onClick={handleClose}
        size="sm"
        color="#757575"
        position="relative"
      />
    </Box>
  )
}
